/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { Link } from 'react-router';

const Terms = () => {
    return (
        <div className="max-w-2xl mx-auto flex flex-col gap-3 text-pretty mt-6 mb-6">
            <ul>
                <li className="underline hover:text-blue-500">
                    <a href="#terms">Terms</a>
                </li>
                <li className="underline hover:text-blue-500">
                    <a href="#privacy">Privacy policy</a>
                </li>
            </ul>
            <h1 className="text-3xl">Preamble</h1>
            <h2 className="text-xl" id="myia-sas">
                MYIA SAS
            </h2>
            <p className="">
                MYIA SAS (hereafter "Provider") is a company with a capital of 100 euros, registered under the number
                844 840 728 R.C.S. Nanterre and whose head office is located at:
            </p>
            <p className="">
                {' '}
                2 Boulevard de Strasbourg
                <br /> 75011 Paris
                <br /> France.
            </p>
            <h2 className="text-xl">heal.dev</h2>
            <p className=" flex flex-col gap-2">
                <div className="">
                    {/* eslint-disable-next-line max-len */}
                    heal.dev (hereafter also designated by “heal” or <strong className="inline">
                        "the Products"
                    </strong>{' '}
                    ) are products developed by MYIA SAS, that allow to run end-to-end testing and quality checks
                    against software products. They allow users to run software testing scenarios against their website
                    or software application and get reports about successful scenarios, unsuccessful scenarios, software
                    defects, and software improvements. The products are comprised of:
                </div>
                <ul className="list-disc list-inside">
                    <li>the software available at https://app.heal.dev</li>
                    <li>the heal.dev chrome extension</li>
                </ul>
            </p>
            <h1 className="text-3xl" id="terms">
                Terms and condition
            </h1>
            <h2 className="text-xl">1. Introduction</h2>
            <p className="">
                The present general terms of use (the "Terms") set the legal framework governing the use of the Product.
                Your use of the Productsis conditioned by your acceptance of the Terms in effect at the time you access
                the Product. If you do not accept the Terms, you may not use the Products.
            </p>
            <h2 className="text-xl">2. Prerequisites</h2>
            <p className="">
                By using the Products, you warrant that you are 18 years old or older and that you are legally eligible
                to enter into a contract.
            </p>
            <h2 className="text-xl">3. Usage of the Products</h2>
            <h3>3.1. Permitted Use.</h3>
            <p className="">
                As long as you agree to and abide by the Terms, and unless we terminate it, we grant you a personal,
                limited, non-exclusive, non-transferable, free, revocable right to access and use the Products in
                accordance with these Terms.
            </p>
            <h4>3.2. Prohibited use and restriction</h4>
            <p className="">
                Any reproduction, representation, exploitation, adaptation or translation of the Products or of any of
                its contents, in whole or in part, for any other purpose on any medium, is prohibited. Any extraction,
                by permanent or temporary transfer to another medium by any means, or reuse by making available to the
                public all or a qualitatively or quantitatively substantial part of heal and/or its contents, is
                prohibited. You agree not to damage, disable or overburden the Products and not to interfere with any
                other party's use of the Products. You agree not to:
                <ol>
                    <li>Copy, modify, distribute, sell, or lease any part of the Products or included software.</li>
                    <li>
                        Copy, decompile, modify, reverse engineer, or create derivative works out of any Confidential
                        Information without the disclosing party's written consent.
                    </li>
                    <li>
                        Use the Products for any illegal purpose or in violation of any local, state, national, or
                        international law.
                    </li>
                    <li>
                        Use the Products to test (or otherwise interact with) software not owned by you, or that you
                        have not obtained permission to interact with from the lawful owner.
                    </li>
                </ol>
            </p>
            <h3 className="text-xl">3. Availability and Accessibility.</h3>
            <p className="">
                We strive to make the Products available at all times, but we cannot guarantee uninterrupted or
                error-free service. We reserve the right to make changes to all or part of the Products at any time,
                including, but not limited to, the right to remove, modify and/or vary the features, functions and
                functionality of the Products. You acknowledge that you may only use the Products if your terminal is
                connected to the Internet. The connection fees charged to you for accessing the Products are subject to
                the terms and conditions of your service provider. You also understand the risks inherent in the use of
                the Internet, including, but not limited to, the fact that the Products may be temporarily unavailable,
                risks in terms of confidentiality or damage to transmitted data, virus attacks, etc. Without prejudice
                to our rights and remedies, we reserve the right to temporarily or permanently suspend your access to
                the Products, at any time, without notice, in the event that you breach any of the provisions of these
                Terms. In the event that we believe that you are making illegal and/or unauthorized use of the Products,
                we reserve the right to take any action we deem necessary, including termination of the agreement
                without notice and, in the case of illegal use, legal action.
                <h4>User responsibility</h4>
                You are responsible for maintaining the confidentiality of your account and password and for restricting
                access to your computer. You agree to accept responsibility for all activities that occur under your
                account or password.
            </p>
            <h3 className="text-xl">4. Liability</h3>
            <p className="">
                The Products are provided "as is" WITHOUT WARRANTY OF ANY KIND. We do not warrant that the Products are
                free of errors or omissions or that the Products will be available and accessible without interruption.
                Access to the Products is permitted on a temporary basis. We may suspend, withdraw, discontinue or
                modify all or part of the Products without notice. You acknowledge that your use of the Products is at
                your own risk. Risks related to the use of the Internet. It is expressly recalled that the Internet is
                not a secure network. We cannot therefore be held liable for contamination by a virus or the intrusion
                of a third party into the system of your terminal and decline all responsibility for the consequences of
                your access to the Products which are not attributable to us. It is therefore your responsibility to
                take all appropriate measures to protect your equipment and the data stored on your equipment against
                any attack. In particular, MYIA SAS or its affiliates cannot be held liable for any conseuqences of
                uisng the Products, including the effect if running tests on a software system.
            </p>
            <h4>Malfunction of the Internet network.</h4>
            <p className="">
                We decline all responsibility in case of malfunction of the Internet network, telephone lines, reception
                equipment preventing access to the Products. Links to third party websites. the Products may contain
                links to third party websites that we do not control. We are not responsible for the privacy practices
                or the content of such websites.
            </p>
            <h3 className="text-xl">5.. Intellectual Property rights</h3>
            <p className="">
                The Products and their contents are protected by intellectual property rights, including copyrights and
                trademarks, which are our exclusive property and/or that of our licensors. These Terms should not be
                construed as a transfer of ownership of the Products or heal.dev to users. All rights related to the
                Products or heal.dev not expressly granted to users are reserved to us.
            </p>
            <h3 className="text-xl">6. Particular terms and conditions for the Products</h3>
            <p className="">
                By using the heal testing tool, you grant MYIA SAS, its affiliates, and its suppliers the right to a
                non-exclusive, worldwide, perpetual, royalty-free, fully paid, sublicensable, fully transferable,
                irrevocable license and right to process all data or information (hereafter "Usage Data") that you
                submit to the heal testing tool, as well as all data heal may collect while interacting with your
                website (including screenshots and page data) (hereafter "Customer Content") for the purpose of
                <ol>
                    <li>operating and improving the heal testing tool</li>
                    <li>
                        to create, generate, derive, or otherwise process deidentified page structure data and page
                        screenshots
                    </li>
                    <li>
                        to develop, train, or enhance artificial intelligence or machine learning models that are part
                        of the Products, including third-party components of the Products. Nothing in this section will
                        reduce or limit Provider's obligations regarding Personal Data that may be contained in Usage
                        Data or Customer Content under Applicable Data Protection Laws. Due to the nature of artificial
                        intelligence and machine learning, information generated by these features may be incorrect or
                        inaccurate. Product features that include artificial intelligence or machine learning models are
                        not human and are not a substitute for human oversight.
                    </li>
                </ol>
            </p>
            <h3 className="text-xl">7. Modification of Terms</h3>
            <p className="">
                We may update these Terms and modify the services described herein at any time, with effect for the
                future only. We will notify you of any material changes by placing a prominent notice on the Products.
                If you do not agree with any changes or modifications to the Terms, we request you not to use the
                Products.
            </p>
            <h3 className="text-xl">8. Applicable law and Dispute resolution</h3>
            <p className="">
                The present Terms are subject to French law. In case of dispute and in order to find an amicable
                solution, we invite you to contact us in priority at contact@heal.dev. In the absence of an amicable
                solution, any dispute relating to the present Terms will be submitted to the competent French
                jurisdictions.
            </p>
            <h3 className="text-xl">9. General</h3>
            <p className="">
                The present Terms constitutes the entire agreement between you and us with respect to the use of the
                Products and supersedes all other communications or advertisements relating to the Products. The Terms
                coexists with, and does not supersede, our Privacy Policy and General Sales Conditions. If any provision
                of these Terms is found to be invalid, in whole or in part, it will not affect the validity of the
                remaining provisions. In no event will your or our failure to exercise any right under these Terms be
                deemed a waiver of such right. Nothing in these Terms shall be construed as conferring, directly or
                indirectly, any benefit or right of action against us to any third party, nor shall any third party have
                the right to enforce any provision of these Terms against us.
            </p>
            <h1 className="text-3xl" id="privacy">
                Privacy Policy
            </h1>
            <p>
                This policy is designed to help you understand how we (MYIA SAS) collect and process your personal data.
                For information about what website and test data we process in the context of providing our services,
                see above.
            </p>
            <h2 className="text-xl">As a visitor of the heal.dev website</h2>
            <ul className="list-disc list-inside">
                <li>We don't collect personal data.</li>
                <li>
                    If you send us a contact request, we will collect your name and email address in order to reply.
                </li>
            </ul>
            <h2 className="text-xl">As a user of heal.dev or of the Products</h2>
            <ul className="list-disc list-inside">
                <li>
                    As a user your name and email will be collected to send you updates and communications subject to
                    your approval.
                </li>
                <li>
                    We use basic cookies to ensure a good browsing experience (e.g. keeping you logged in to the app)
                    but not for tracking or advertising purposes.
                </li>
                <li>If you purchase a paying plan, we will additionally collect billing information.</li>
                <li>
                    We use Sentry for exception management and logging in our agent, backend and frontend. Sentry is
                    <Link to="https://blog.sentry.io/gdpr-sentry-and-you/">GDPR compliant</Link>.
                </li>
                <li>
                    We collect your email address and or name along with session replay data, provided by Sentry (
                    <Link to="https://sentry.io/legal/dpa/5.1.0/in-app/?userCurrentVersion=5.1.0">DPA</Link>), in order
                    to provide customer support and to improve the agent.
                </li>
                <li>
                    We use Betterstack for logging (<Link to="https://betterstack.com/dpa">DPA</Link>).
                </li>
            </ul>
            <p>
                Data is shared with selected third-parties services strictly in the context of providing our services.
                This includes Heroku, Clerk and GCP. These parties are not authorised to use this data other than to
                provide the service.
            </p>
            <h2 className="text-xl">Retention</h2>
            We keep your data as long as your account is active, or as long it is necessary to provide our Products.This
            data is also used to comply with our legal obligations, resolve disputes, enforce our agreements, and
            protect MYIA SAS's rights.
            <h2 className="text-xl">Deleting data</h2>
            <p>Users can change or delete their personal data by reaching out to us at contact [at] heal.dev.</p>
            <h2 className="text-xl">About this policy</h2>
            <p>
                This privacy policy can be updated as our business evolves and to meet regulatory changes. Important
                updates will be communicated by email.
            </p>
        </div>
    );
};

export default Terms;
